import Slider from 'react-slick';
import SliderArrow from '~/js/components/SliderArrow';
import iconData from '../mockup/amenitiesiconData';

const internals = {};

internals.commaRegex = /,/g;

internals.sliderOptions = {
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    // variableWidth: true,
    // adaptiveHeight: true,
    fade: true,
    autoplay: false,
    centerMode: true,
    centerPadding: '0',
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 100,
    dots: false,
    nextArrow: <SliderArrow classNames="slider-arrow slider-arrow-next"/>,
    prevArrow: <SliderArrow classNames="slider-arrow slider-arrow-prev"/>
};

function getAmenityList(room, features) {

    const amenityList = [
        'rollsRoyceTransfer', 'privateCarTransfer', 'roomService',
        'conciergeService', 'butlerService', 'handicapFriendly',
        'loveNest', 'choicePremiumSpirits', 'premiumSpirits',
        'beerWine', 'airportTransfers', 'ic-boat'
    ];
    const amenityFeaturedList = ['Free WIFI', 'Soaking Tubs'];

    return [
        ...features.filter(amenity => amenityFeaturedList.includes(amenity)),
        ...amenityList.filter(amenity => room[amenity] === true)
    ];
}

function renderAmenityIcons(room, features = []) {

    // const { iconData } = internals;
    const amenities = getAmenityList(room, features);

    return amenities.map(amenity => {

        const { className, popover, featureName } = iconData[amenity];

        return (
            <a
                key={ ['icon', room.roomCategoryCode, amenity].join('-') }
                className={ `ic ${ className } ic-large js-popover` }
                href={'#' + popover}
            >
                <span className="sr-only">{featureName}</span>
            </a>
        );
    });


}

class Card extends React.Component {

    static getDerivedStateFromProps(nextProps, prevState) {

        // if (nextProps.isGrid !== prevState.isGrid) {
        //     return {
        //         isGrid: nextProps.isGrid
        //     };
        // }

        return {
            ...prevState,
            ...nextProps
        };
    }

    constructor(props) {
        super(props);

        this.slider = React.createRef();
        this.scrollRef = React.createRef();
        this.state = {};

        this.isMobile = window.innerWidth < 768;
    }

    componentDidUpdate() {
        if (this.getUrlParameter('scroll') === this.props.room.roomCategoryCode) {
            this.scrollToElement();
        }
        this.slider.current.forceUpdate();
    }

    getUrlParameter = sParam => {
        const sPageURL = decodeURIComponent(window.location.search.substring(1));
        const sURLVariables = sPageURL.split('&');
        let sParameterName;
        let i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    scrollToElement() {
        const containerOffset = (this.scrollRef.current.offsetTop);

        window.scrollTo({
            top: (containerOffset - 150),
            behavior: 'smooth'
        });
    }

    render() {
        const { room, rate, features, resortCode, uris, countIcons } = this.props;
        const { isGrid = true } =  this.state;
        const { sliderOptions } = internals;
        const {
            roomCategoryName = '',
            roomDescription = '',
            additionalImageCodes: images = '',
            roomWebImageCode: primaryImage = '',
            roomCategoryView = 'N/A',
            //roomCategorytId = '',
            roomCategoryCode = '',
         } = room;
        const hasLoveNest = room.loveNest;

        const uriRoomsSuitesDetails =  uris[`${ resortCode }_rooms_and_suites_details`] || '#';

        const allImages = images.split(',', images.length);

        const firstImage = primaryImage.split(',', primaryImage.length);

        const roomImages = [...firstImage, ...allImages];

        return (
            <div
            ref={this.getUrlParameter('scroll') === this.props.room.roomCategoryCode ? this.scrollRef :  ''}
            className={`col-xs-12 ${ isGrid && 'col-sm-6 col-md-4'}`}
            >
                <div className={ `list-grid-viewer-item ${!isGrid && 'row'}`}>
                    <div className={ isGrid ? '' : 'col-xs-12 col-sm-6 col-md-6 col-lg-4'}>
                        <div className="list-grid-viewer-item-shadow js-list-grid-viewer-viewport">
                            <div className={`list-grid-viewer-slider ${ hasLoveNest && 'love-nest'}`}>
                                <a href={`${ uriRoomsSuitesDetails }?categoryCode=${ roomCategoryCode }`}>
                                    <Slider ref={this.slider} {...sliderOptions}>
                                        {
                                            roomImages.map(imageCode => {

                                                const source = `//cdn.sandals.com/sandals/v13/images/EN/resorts/${resortCode}/accommodations/large/${resortCode}-${imageCode}.jpg`;

                                                return (
                                                    <div key={`image-${resortCode + imageCode}`} className="slider-item">
                                                        <img alt={`Slide ${ imageCode }`}
                                                            src={ source }
                                                            data-lazy={ source } />
                                                    </div>
                                                );
                                            })
                                        }
                                    </Slider>
                                </a>
                            </div>
                            <div className="list-grid-viewer-description">
                                <div className="text-description">
                                    { roomCategoryName } { roomCategoryCode.length > 0 ? `- ${ roomCategoryCode.toUpperCase() }` : '' }
                                </div>
                                <div className="price-description text-center">
                                    <div className="price-details">
                                        <div className="details-wrapper">
                                            <div className="main-details">
                                                <span>ROOM VIEW:</span> { roomCategoryView.trim().replace(internals.commaRegex, ', ') || 'N/A' }
                                            </div>
                                            <div className={`additional-details ${ (countIcons >= 6) ? 'alot-of-icons' : '' }`}>
                                                { renderAmenityIcons(room, features) }
                                            </div>
                                        </div>
                                        
                                                <a className="link-more" href={`${ uriRoomsSuitesDetails }?categoryCode=${ roomCategoryCode }`}>Room Details</a>
                                        
                                        
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        !isGrid && (
                        <div className="hidden-xs col-sm-6 col-md-6 col-lg-8">
                            <div className="list-grid-viewer-full-info col-sm-12 col-md-12 col-lg-12">
                                <h3>{ roomCategoryName } { roomCategoryCode.length > 0 ? `- ${ roomCategoryCode.toUpperCase() }` : '' }</h3>
                                <p>{ roomDescription }</p>
                            </div>
                        </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

Card.defaultProps = {
    room: {},
    rate: {},
    features: [],
    resortCode: '',
    uris: {},
    countIcons: 0,
};

export default Card;
